class ShopifyProductForm {

    elements = {};

    constructor(wrapper) {
        this.loadElements(wrapper);
        this.setEventListeners();
    }

    loadElements(wrapper) {
        this.elements.wrapper = wrapper;
        this.elements.quantityInput = wrapper.find('.quantity--input__input');
        this.elements.incrementQuantity = wrapper.find('.quantity--input__button.quantity--input__decr');
        this.elements.decrementQuantity = wrapper.find('.quantity--input__button.quantity--input__incr');
        this.elements.addToCart = wrapper.find('.button--addToCart');
    }

    setEventListeners() {
        this.elements.quantityInput.get(0).onchange = () => {
            this.announceQuantityUpdate();
        };
    }

    announceQuantityUpdate() {
        jQuery(document).trigger('shopify-product-form-quantity-update');
    }

    getQuantity() {
        return parseInt(this.elements.quantityInput.val());
    }

    incrementQuantity() {
        this.elements.incrementQuantity.get(0).click();
    }

    decrementQuantity() {
        this.elements.decrementQuantity.get(0).click();
    }

    setQuantity(val) {
        this.elements.quantityInput.val(val);
        this.announceQuantityUpdate();
    }

    addToCart() {
        this.elements.addToCart.get(0).click();
    }

}

var shopifyProductForm = [];

jQuery('.shopify-product-form').each(
    function() {
        shopifyProductForm.push(new ShopifyProductForm(jQuery(this)));
    }
);
